<!-- 课程设置 -->
<template>
  <div>
    <div class="course_SetUp">
      <el-button
        type="warning"
        size="small"
        @click="toggleRowExpansion(true)"
        icon="el-icon-arrow-down"
        style="background-color:#FFBA00;"
        >全部展开</el-button
      >
      <el-button
        type="danger"
        size="small"
        @click="toggleRowExpansion(false)"
        icon="el-icon-arrow-up"
        style="background-color: #FF2D2D;"
        >全部折叠</el-button
      >
      <el-row class="mt20">
        <el-table
          :data="tableData"
          style="width: 100%;margin-bottom: 20px;"
          row-key="teacherOpenCourseMergeCourseInfoId"
          border
          lazy
          ref="dataTreeList"
          default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren1' }"
        >
          <el-table-column
            prop="courseInfoNo"
            width="200"
            label="序号"
            sortable
          ></el-table-column>
          <el-table-column prop="courseInfoName" label="目录名称" sortable>
            <template v-slot="scope">
              <template v-if="scope.row.courseInfoType == 2">
                <p class="m0" style="padding-left: 20px;">
                  {{ scope.row.courseInfoName }}
                </p>
              </template>
              <template v-if="scope.row.courseInfoType == 3">
                <p class="m0" style="padding-left: 40px;">
                  {{ scope.row.courseInfoName }}
                </p>
              </template>
              <template v-if="scope.row.courseInfoType == 4">
                <p class="m0" style="padding-left: 60px;">
                  {{ scope.row.courseInfoName }}
                </p>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="资源类型"
            header-align="center"
            align="left"
            sortable
            width="180"
          >
            <template v-slot="scope">
              <!-- 1	视频 2	PPT 3	PDF 4	链接 5	图文 -->
              <template v-if="scope.row.resourcesInfoType == 1">
                <el-image class="setUp_img" :src="video_img"></el-image>
                <p class="m0">视频</p>
              </template>
              <template v-if="scope.row.resourcesInfoType == 2">
                <template
                  v-if="$matchType(scope.row.resourcesInfoContent) == 'word'"
                >
                  <el-image class="setUp_img" :src="word_img"></el-image>
                  <p class="m0">word</p>
                </template>
                <template
                  v-if="$matchType(scope.row.resourcesInfoContent) == 'ppt'"
                >
                  <el-image class="setUp_img" :src="ppt_img"></el-image>
                  <p class="m0">PPT</p>
                </template>
                <template
                  v-if="$matchType(scope.row.resourcesInfoContent) == 'pdf'"
                >
                  <el-image class="setUp_img" :src="pdf_img"></el-image>
                  <p class="m0">PDF</p>
                </template>
              </template>
              <template v-if="scope.row.resourcesInfoType == 3">
                <el-image class="setUp_img" :src="pdf_img"></el-image>
                <p class="m0">PDF</p>
              </template>
              <template v-if="scope.row.resourcesInfoType == 4">
                <el-image class="setUp_img" :src="link_img"></el-image>
                <p class="m0">链接</p>
              </template>
              <template v-if="scope.row.resourcesInfoType == 5">
                <el-image class="setUp_img" :src="img_img"></el-image>
                <p class="m0">图片</p>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <!-- 资源的操作 -->
              <template v-if="scope.row.courseInfoType == 4">
                <el-button @click="look(scope.row)" type="text" size="small"
                  >查看</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </div>
  </div>
</template>
<script>
import RichText from "@/components/RichText/index";
import UploadFile from "@/components/UploadFile"; //上传图片
export default {
  name: "SetUp",
  props: {
    courseId: {
      //课程ID
      type: String,
      required: true
    },
    courseType: {
      //课程类型 1：开课 2：授权课
      type: String,
      required: true
    }
  },
  components: {
    UploadFile,
    RichText
  },
  data() {
    return {
      ppt_img: require("../../../images/course/ppt@2x.png"),
      word_img: require("../../../images/course/word@2x.png"),
      pdf_img: require("../../../images/course/pdf@2x.png"),
      video_img: require("../../../images/course/shipinwenjian@2x.png"),
      link_img: require("../../../images/course/link@2x.png"),
      img_img: require("../../../images/course/tupian@2x.png"),
      tableData: [],
      importShow: false,
      importId: "",
      courseImportList: [],
      onCourseInfoId: "", //当前操作的章节ID
      uploadPoolShow: false,
      poolSearch: {},
      tablePool: [],

      total: 0,
      limit: 10,
      page: 1,
      linkShow: false,
      linkForm: {},
      imgShow: false,
      imgForm: {},
      uploadFileShow: false,
      uploadFile: {
        resourcesInfoContent: "", //文件地址
        resourcesInfoName: ""
      }
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {},
  methods: {
    toggleRowExpansion(isExpansion) {
      this.toggleRowExpansion_forAll(this.tableData, isExpansion);
    },
    toggleRowExpansion_forAll(data, isExpansion) {
      data.forEach(item => {
        this.$refs.dataTreeList.toggleRowExpansion(item, isExpansion);
        if (item.children != undefined && item.children != null) {
          this.toggleRowExpansion_forAll(item.children, isExpansion);
        }
      });
    },
    getInfo() {
      if (this.courseType == 1) {
        let url =
          "/api/teacherOpenCourseMergeCourseInfo/getTreeByTeacherOpenCourseId.do";
        this.$post(url, { teacherOpenCourseId: this.courseId }).then(ret => {
          if (ret.code == 0) {
            if (!this.$isEmpty(ret.data) && !this.$isEmpty(ret.data.children)) {
              this.tableData = ret.data.children;
              for (let item in this.tableData) {
                //处理resourcesInfo[] 资源数据匹配入
                this.tableData[item].courseInfoNo = this.$numberfilter(
                  Number(item) + 1
                );
                for (let it in this.tableData[item].children) {
                  this.tableData[item].children[it].courseInfoNo =
                    Number(it) + 1;
                  this.tableData[item].children[it].children = this.tableData[
                    item
                  ].children[it].resourcesInfo;
                  for (let i in this.tableData[item].children[it].children) {
                    //this.tableData[item].children[it].children[i].courseInfoNo = Number(item) + 1 +'.' + (Number(it) + 1)+'.' + (Number(i) + 1);
                    this.tableData[item].children[it].children[
                      i
                    ].courseInfoType = 4;
                    this.tableData[item].children[it].children[
                      i
                    ].courseInfoName = this.tableData[item].children[
                      it
                    ].children[i].resourcesInfoName;
                    this.tableData[item].children[it].children[
                      i
                    ].teacherOpenCourseMergeCourseInfoId =
                      this.tableData[item].children[it].children[i]
                        .teacherOpenCourseMergeCourseInfoId +
                      this.tableData[item].children[it].children[i]
                        .teacherOpenCourseMergeResourcesInfoId;
                  }
                }
              }
              console.log(this.tableData);
            }
          }
        });
      } else if (this.courseType == 2) {
        let url = "/api/courseInfo/getCourseCenterResources.do";
        this.$get(url, { courseInfoId: this.courseId }).then(ret => {
          if (ret.code == 0) {
            let courseInfoAllData = ret.data;
            let zjList = [],
              zNum = 0; //章节
            let xjList = {}; //小节
            let kjList = []; //课件
            courseInfoAllData.forEach((item, index) => {
              if (item.courseInfoType == 2) {
                //章
                zNum++;
                item.courseInfoNo = this.$numberfilter(Number(zNum));
                item.teacherOpenCourseMergeCourseInfoId = item.courseInfoId;
                zjList.push(item);
              }
              if (item.courseInfoType == 3) {
                //节 resourcesInfo：课件
                item.teacherOpenCourseMergeCourseInfoId = item.courseInfoId;

                if (
                  this.$isEmpty(xjList[item.courseInfoParentId]) ||
                  xjList[item.courseInfoParentId].length <= 0
                ) {
                  xjList[item.courseInfoParentId] = [];
                  item.courseInfoNo =
                    xjList[item.courseInfoParentId].length + 1;
                  item.children = item.resourcesInfo;
                  xjList[item.courseInfoParentId].push(item);
                } else {
                  item.courseInfoNo =
                    xjList[item.courseInfoParentId].length + 1;
                  item.children = item.resourcesInfo;
                  xjList[item.courseInfoParentId].push(item);
                }
              }
            });
            zjList.forEach((item, index) => {
              item.children = xjList[item.courseInfoId];
              if (!this.$isEmpty(item.children)) {
                item.children.forEach((it, ind) => {
                  if (!this.$isEmpty(it.children)) {
                    it.children.forEach((itt, indx) => {
                      itt.courseInfoType = 4;
                      itt.courseInfoName = itt.resourcesInfoName;
                      itt.teacherOpenCourseMergeCourseInfoId =
                        10000 + Number(itt.resourcesInfoId);
                      // item.children[index].children[ind].children[indx].teacherOpenCourseMergeCourseInfoId = 10000 + it.resourcesInfoId;
                    });
                  }
                });
              }
            });
            this.tableData = zjList;
          }
        });
      }
    },
    look(item) {
      //查看课件
      if (item.resourcesInfoType == 4) {
        window.open(
          item.resourcesInfoContent.indexOf("http") == 0
            ? item.resourcesInfoContent
            : "http://" + item.resourcesInfoContent
        );
      } else {
        this.$router.push({
          name: "CoursewareViewing",
          query: {
            courseType: this.courseType,
            courseId: this.courseId,
            onId: item.teacherOpenCourseMergeCourseInfoId
          }
        });
      }
    },
    importInfo() {
      //系统导入课程设计
      this.importId = "";
      this.importShow = true;
      this.courseInfoPageByUniColleges();
    },
    courseInfoPageByUniColleges() {
      //获取归属课程
      if (this.courseImportList.length > 0) {
        //为空时在调用，避免每次都调用占用资源
        return;
      }
      this.$post("/api/courseInfo/courseInfoPageByUniCollegesId.do").then(
        ret => {
          if (ret.code == 0) {
            this.courseImportList = ret.data;
          }
        }
      );
    }
  }
};
</script>
<style lang="less">
.course_SetUp {
  .has-gutter th {
    background-color: #f9f9fa;
  }
  .setUp_img {
    width: 20px;
    float: left;
    margin-right: 10px;
    margin-left: 50px;
  }
  .el-table .el-table__cell {
    padding: 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/lookCourse/components/SetUp.vue